import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import moment from 'moment-timezone';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import { CREATE_USER } from '../../../graphql/Mutations';
import AmbassadorForm from '../components/AmbassadorForm';

const CreateAmbassador = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const { dispatch } = useContext(AppContext);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const [createUser] = useMutation(CREATE_USER, {
    onError: () => {},
  });

  const createAmbassadorFun = async (ambassadorDetails) => {
    setIsSubmitLoading(true);
    dispatch({
      type: 'SET_SHOW_PROMPT',
      data: false,
    });
    
    // Split name into first and last name
    const nameParts = ambassadorDetails?.name?.trim()?.split(' ');
    const firstName = nameParts?.[0] || '';
    const lastName = nameParts?.slice(1)?.join(' ') || '';

    const response = await createUser({
      variables: {
        data: {
          firstName,
          lastName,
          gender: ambassadorDetails?.gender,
          city: ambassadorDetails?.city,
          state: ambassadorDetails?.state,
          roles: ['AMBASSADOR'],
          contactNo: ambassadorDetails?.contact?.trim(),
          address: ambassadorDetails?.address?.trim(),
          address2: ambassadorDetails?.address2?.trim(),
          locality: ambassadorDetails?.locality?.trim(),
          landmark: ambassadorDetails?.landmark?.trim(),
          email: ambassadorDetails?.email?.trim(),
          pincode: ambassadorDetails?.pincode,
          isAmbassadorActive: ambassadorDetails?.isAmbassadorActive,
          timezone: moment?.tz?.guess(),
        },
      },
    });
    if (response?.data) {
      history?.replace(`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`);
    }
    setIsSubmitLoading(false);
  };

  const handleShowPrompt = () => {
    setIsDisabled(false);
    dispatch({
      type: 'SET_SHOW_PROMPT',
      data: true,
    });
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton customLink={ROUTES?.SYSTEM_USERS} />
        <div className="portal-header">Add New Ambassador</div>
      </Portal>
      <Portal portalId="header-right-content">
        <div className="header-btn-wrapper">
          <Button
            type="primary"
            className="common-button mr-16"
            size="middle"
            onClick={() =>
              history?.push(`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`)
            }
          >
            Cancel
          </Button>
          <Button
            className="common-button"
            size="middle"
            onClick={form.submit}
            loading={isSubmitLoading}
            disabled={isDisabled}
          >
            Save
          </Button>
        </div>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <div className="header-btn-wrapper">
          <Button
            type="primary"
            className="common-button mr-16"
            size="middle"
            onClick={() =>
              history?.push(`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`)
            }
          >
            Cancel
          </Button>
          <Button
            className="common-button"
            size="middle"
            onClick={form.submit}
            loading={isSubmitLoading}
            disabled={isDisabled}
          >
            Save
          </Button>
        </div>
      </Portal>
      <Card className="full-height-with-nav" title="Ambassador Details">
        <div className="admin-form">
          <AmbassadorForm
            form={form}
            onFinish={createAmbassadorFun}
            handleShowPrompt={handleShowPrompt}
          />
        </div>
      </Card>
    </>
  );
};

export default CreateAmbassador;
